import { FC } from 'react';
import { NavItemType } from '../types/menu';
import { useLocation, useNavigate } from 'react-router';
import { ButtonBase, Stack, Typography, useTheme } from '@mui/material';
import { AccountCircleOutlined, Groups3Outlined } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { Location } from 'react-router-dom';
import { ThemeMode } from '../types/config';
import { useOrganizationMenuItems } from '../menu-items/organization';
import { usePersonalMenuItems } from '../menu-items/personal';

const SubmenuItem: FC<{ readonly item: NavItemType }> = ({ item }) => {
	const navigateTo = useNavigate();
	const location = useLocation();
	const theme = useTheme();
	const isActive = item.isActive ?? ((location: Location): boolean => location.pathname === item.url);
	const activeColor = theme.palette.mode === ThemeMode.DARK ? theme.palette.night.A100 : theme.palette.day[800];
	const defaultColor = theme.palette.mode === ThemeMode.DARK ? theme.palette.night[700] : theme.palette.day[700];

	return (
		<ButtonBase onClick={() => navigateTo(item.url ?? '')} sx={{ width: '100%' }} key={item.id}>
			<Stack sx={{ cursor: 'pointer' }} width={'100%'} textAlign={'left'} pl={3} color={isActive(location) ? activeColor : defaultColor}>
				<Typography fontWeight={500} lineHeight={2} sx={{ textDecoration: isActive(location) ? 'underline' : 'none' }}>
					{item.title}
				</Typography>
			</Stack>
		</ButtonBase>
	);
};

export const SettingsNavigation: FC = () => {
	const personalMenuItems = usePersonalMenuItems();
	const organizationMenuItems = useOrganizationMenuItems();

	return (
		<Stack flexDirection={'column'} alignItems={'flex-start'} spacing={4} sx={{ position: 'sticky', top: (theme) => theme.spacing(8) }}>
			<Stack>
				<Stack alignItems={'center'} mb={1} display={'flex'} color={'#8C8C8C'} direction={'row'} spacing={1}>
					<AccountCircleOutlined sx={{ width: '18px', height: '18px' }} />
					<Typography textTransform={'uppercase'} fontSize={'12px'} lineHeight={'20px'}>
						<FormattedMessage id={'settings.navigation.title.personal'} />
					</Typography>
				</Stack>
				<Stack spacing={1}>
					{personalMenuItems.map((item) => (
						<SubmenuItem key={item.id} item={item} />
					))}
				</Stack>
			</Stack>
			<Stack>
				<Stack alignItems={'center'} mb={1} display={'flex'} color={'#8C8C8C'} direction={'row'} spacing={1}>
					<Groups3Outlined sx={{ width: '18px', height: '18px' }} />
					<Typography textTransform={'uppercase'} fontSize={'12px'} lineHeight={'20px'}>
						<FormattedMessage id={'settings.navigation.title.organizations'} />
					</Typography>
				</Stack>
				<Stack spacing={1}>
					{organizationMenuItems.map((item) => (
						<SubmenuItem key={item.id} item={item} />
					))}
				</Stack>
			</Stack>
		</Stack>
	);
};
